import * as React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export interface SkelProps {
  width?: string | number;
  height: number;
  borderRadius?: number;
}

// Base shimmer block. Uses ui/skeleton (which carries the `animate-shimmer`
// keyframe wired to the --bg-muted gradient in tailwind.config.js).
export function Skel({ width = '100%', height, borderRadius = 6 }: SkelProps) {
  return (
    <Skeleton
      data-testid="skel"
      style={{ width, height, borderRadius }}
    />
  );
}

// Per design spec (04-global-components.html §4 + README §4e).
export function MetricCardSkeleton() {
  return (
    <div
      data-testid="metric-card-skeleton"
      style={{
        background: 'var(--bg-primary, #fff)',
        border: '1px solid var(--border)',
        borderRadius: 12,
        padding: '18px 20px',
        boxShadow: 'var(--shadow-card)',
      }}
    >
      <Skel width={80} height={10} borderRadius={6} />
      <div style={{ height: 12 }} />
      <Skel width={60} height={28} borderRadius={4} />
    </div>
  );
}

export interface TableRowSkeletonProps {
  cols: number[]; // per-column skeleton bar widths (px)
}

export function TableRowSkeleton({ cols }: TableRowSkeletonProps) {
  return (
    <tr data-testid="table-row-skeleton">
      {cols.map((w, i) => (
        <td
          key={i}
          style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)' }}
        >
          <Skel width={w} height={12} />
        </td>
      ))}
    </tr>
  );
}

export default Skel;
